module.exports = __webpack_public_path__ + "static/media/fontello.34c08816.woff2";